import moment from "moment";

function ProofOfPlayMultiLocationCtrl(
  $scope,
  $state,
  $stateParams,
  sweet,
  DateManipulationService,
  ProofPlayService,
  ProofOfPlayReportsV2Service,
  ToastsService
) {
  "ngInject";

  let vm = this;

  vm.radioButtonChoices = {
    group1: 'By Device',
    group2: 'Summarized',
    selection: null
  };

  vm.dateTimeSelection = {
    start: null,
    end: null
  };

  vm.formValidity = {
    start_date: false,
    end_date: false,
    locations: false,
  };

  vm.tenant = $stateParams.tenantId;
  vm.loading = true;
  vm.disabled = true;
  vm.disabledTenant = true;
  vm.selected_locations = [];

  vm.initialize = () => {
    ProofPlayService.getAllLocations(vm.tenant)
      .then(function (data) {
        vm.loading = false;
        vm.locations = data.data.locations;
        if (vm.locations.length > 0) {
          return vm.had_some_items = true;
        } else {
          return vm.had_some_items = false;
        }
      })
  };

  vm.refreshLocations = function () {
    vm.searchText = '';
    vm.selectedItem = '';
    vm.loading = true;
    vm.disabled = true;
    vm.selected_locations = [];
    vm.initialize();
  };

  vm.addToSelectedLocations = function (searchText) {
    if (vm.isLocationValid(searchText)) {
      vm.selected_locations.push(searchText);
      let index = vm.locations.indexOf(searchText);
      vm.locations.splice(index, 1);
      vm.searchText = '';
    }
    vm.areLocationsValid();
    return vm.isDisabled();
  };

  vm.querySearch = (locations, searchText) => {
    ProofPlayService.querySearch(locations, searchText);
  }

  vm.isRadioValid = function (selection) {
    vm.formValidity.type = selection;
    return vm.isDisabled();
  };


  vm.isLocationValid = function (searchText) {
    if (__in__(searchText, vm.locations)) {
      if (!__in__(searchText, vm.selected_locations)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  vm.areLocationsValid = function () {
    vm.formValidity.locations = (vm.selected_locations.length > 0);
    return vm.isDisabled();
  };

  vm.isStartDateValid = function (start_date) {
    vm.formValidity.start_date = (start_date instanceof Date);
    return vm.isDisabled();
  };


  vm.isEndDateValid = function (end_date) {
    vm.formValidity.end_date = (end_date instanceof Date);
    return vm.isDisabled();
  };

  vm.removeFromSelectedLocation = function (item) {
    let index = vm.selected_locations.indexOf(item);
    vm.selected_locations.splice(index, 1);
    vm.locations.push(item);
    vm.areLocationsValid();
    return vm.isDisabled();
  };


  vm.isDisabled = function () {
    if (vm.formValidity.start_date && vm.formValidity.end_date && vm.formValidity.locations && vm.formValidity.type) {
      vm.disabled = false;
      vm.final = {
        start_date: DateManipulationService.isoDate(vm.dateTimeSelection.start),
        end_date: DateManipulationService.isoDate(vm.dateTimeSelection.end),
        locations: vm.selected_locations,
        type: vm.radioButtonChoices.selection

      };

    } else {
      vm.disabled = true;
    }
  };

  vm.submit = function () {
    let reportType = {
      '1': 'MULTI_LOCATION_BY_DEVICE',
      '2': 'MULTI_LOCATION_SUMMARIZED',
    }[vm.final.type];
    let data = {
      'tenantId': vm.tenant,  // this is actually tenantId
      'type': reportType,
      'startDate': vm.final.start_date,
      'endDate': vm.final.end_date,
      'parameters': {
        'customerLocationCodes': vm.final.locations,
      }
    };
    return ProofOfPlayReportsV2Service.post(data)
      .then(() => {
        return $scope.changeToReportList();
        //return $state.go('tenantProofPlay',
          //{tenantId: $stateParams.tenantId});  // explicitly passing because the routes aren't siblings (they aren't acually nested)
      }, () => {
        return sweet.show('Oops...', 'There was a problem queueing the report.', 'error');
      });
  };

  vm.currentTenant = vm.tenant;

  vm.querySearch = (resources, searchText) => ProofPlayService.querySearch(resources, searchText);

  return vm;
};

function __in__(needle, haystack) {
  return haystack.indexOf(needle) >= 0;
}

export {ProofOfPlayMultiLocationCtrl}
